import React, { useCallback, useState } from 'react';
import { ModalTitle } from '@strava/ui/Modal';
import { isEmpty } from 'lodash-es';
import SuggestedFriendList from 'components/shared/friends/SuggestedFriendList';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { t } from '../../../../shared/onboardingUtils';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import OnboardingModalActions from '../../../OnboardingModalActions';
import OnboardingFacepile from '../../../OnboardingFacepile';

import styles from './SuggestedFriends.scss';

const SuggestedFriends = () => {
  const { state, track, dispatch } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });
  const { alert, suggestions, currentAthlete } = state;

  const [isSkipBtn, setIsSkipBtn] = useState(true);
  const [facepileAthletes, setFacepileAthletes] = useState([]);

  const handleFollowingFriendsChange = useCallback((followedFriends) => {
    const friendList = Object.values(followedFriends);
    setFacepileAthletes(friendList);
    if (friendList.length > 0) {
      setIsSkipBtn(false);
    } else {
      setIsSkipBtn(true);
    }
  }, []);

  const friendCountMessage = (() => {
    if (suggestions.length === 1) {
      return t('suggested_friends.friend_list.one_friend_to_follow');
    }
    return t('suggested_friends.friend_list.more_friends_to_follow', {
      friend_count: suggestions.length
    });
  })();

  return (
    <>
      <ModalTitle id="onboarding-step-title">
        {t('suggested_friends.title')}
      </ModalTitle>
      <ModalBodyWithAlerts alert={alert} className={styles.modal}>
        <p>{t('suggested_friends.message')}</p>
        <p>{friendCountMessage}</p>
        {!isEmpty(suggestions) && (
          <SuggestedFriendList
            suggestions={suggestions}
            currentAthlete={currentAthlete}
            track={track}
            onFollowingFriendsChange={handleFollowingFriendsChange}
          />
        )}
      </ModalBodyWithAlerts>

      <OnboardingModalActions className={styles.modalActions}>
        <OnboardingFacepile athletes={facepileAthletes} showText={true} />
        <ActionButton
          variant={isSkipBtn ? 'default' : 'primary'}
          onClick={() =>
            stepForward({
              analyticsElement: isSkipBtn ? ACTIONS.skip : ACTIONS.next
            })
          }
          data-cy="suggested-friends-next-step-btn"
          isProcessing={isProcessing}
        >
          {t(`cta_actions.${isSkipBtn ? 'skip' : 'next'}`)}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default SuggestedFriends;
